import React from 'react';
import ComprehensiveAnalyticsDashboard from '@/components/ComprehensiveAnalyticsDashboard';

export const AnalyticsPage: React.FC = () => {
  return <ComprehensiveAnalyticsDashboard />;
};